import { useState } from 'react';
import {
	tokens,
	Spinner,
	makeStyles,
	Caption1,
	Subtitle1,
	Button,
	LargeTitle,
	Body2
} from '@fluentui/react-components';
import { useFetchGameDetailsQuery } from '../Api/Games/gamesSlice';
import { useNavigate, useParams } from 'react-router';
import { useAppSelector } from '../pgStore';
import GameFormModal from './Form/GameFormModal';
import BoxArt from '../Shared/BoxArt';
import ReviewToolstrip from '../Shared/ReviewToolstrip';

export default function GameDetails() {
	const styles = useStyles();
	const { game } = useParams();
	const { data } = useFetchGameDetailsQuery(Number(game));
	const user = useAppSelector((state) => state.userSlice);
	const isOwner = user.username === 'SneakySquid';
	const [showGameForm, setShowGameForm] = useState(false);
	const navigator = useNavigate();

	return (
		<>
			{!data && (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						width: '100%',
						height: '100%'
					}}
				>
					<Spinner />
				</div>
			)}
			{data && (
				<div className={styles.root}>
					<div
						style={{
							flexShrink: 0,
							height: '250px',
							width: '100%'
						}}
					>
						<BoxArt
							imageSrc={data.boxArtUrl}
							altText={''}
							containerOptions={{
								width: '100%',
								height: '250px'
							}}
							imageOptions={{
								minHeight: '100%'
							}}
							splash
						/>
					</div>

					<div style={{ display: 'flex', columnGap: '15px' }}>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								rowGap: '5px'
							}}
						>
							<LargeTitle>{data.title}</LargeTitle>
							<div
								style={{
									display: 'flex',
									columnGap: '4px',
									flexWrap: 'wrap',
									rowGap: '2px',
									overflowY: 'auto'
								}}
							>
								{data.availableOnConsoles.map((platform) => (
									<Caption1
										key={platform.name.replaceAll(' ', '')}
										className={styles.platform}
									>
										{platform.name}
									</Caption1>
								))}
							</div>
							<Subtitle1>
								Release Date: {data.releaseDate}
							</Subtitle1>
							<Body2>{data.description}</Body2>
						</div>

						<div style={{ marginLeft: 'auto' }}>
							{user.authenticated && (
								<Button
									appearance='primary'
									onClick={() =>
										void navigator(
											`/reviews/create?gameId=${String(
												data.id
											)}`
										)
									}
								>
									Review
								</Button>
							)}
							{isOwner && (
								<Button
									appearance='subtle'
									onClick={() => {
										setShowGameForm(true);
									}}
								>
									Edit
								</Button>
							)}
						</div>
					</div>

					<div className={styles.reviews}>
						<ReviewToolstrip
							title={`${data.title} Reviews`}
							gameId={data.id}
						/>
					</div>
				</div>
			)}
			{isOwner && showGameForm && (
				<GameFormModal
					showModal={showGameForm}
					setShowModal={setShowGameForm}
					game={data}
				/>
			)}
		</>
	);
}

const useStyles = makeStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		rowGap: '15px',
		width: '80%',
		minWidth: '400px',
		height: '100%'
	},
	platform: {
		backgroundColor: tokens.colorBrandBackground,
		textAlign: 'center',
		borderRadius: '3px',
		padding: '2px 4px'
	},
	reviews: {
		marginTop: 'auto'
	}
});
